import React from 'react';
import { Link } from 'react-router-dom';
import {Grid, Row, Col} from 'react-flexbox-grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import NavigationLinks from './navigationLinks';
import Hidden from '@material-ui/core/Hidden';
import Img from 'gatsby-image'

import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

export default class Header extends React.Component {
    state = {
	openSideMenu: false
    }
    
    toggleSideMenu = () => {
	this.setState({ openSideMenu: !this.state.openSideMenu });
    };
    
    render(){
    var imgs = this.props.imgs;
	const drawer = <Drawer
			   anchor='right'
			   open={this.state.openSideMenu}
			   onClose={this.toggleSideMenu}
		       >
	    <div style={{width: 300}}>
		<NavigationLinks fullWidth clickCallback={this.toggleSideMenu}/>
		</div>
	</Drawer>;
	
	return (
	    <AppBar elevation={0}>
	        <Toolbar>
		    <Hidden smDown>
			<Grid style={{display: 'flex'}}>
			    <div style={{display: 'flex', flex: 1}}>
				<Link to="/">
				    <Img style={{width: "175px"}} sizes={imgs.logo.white.childImageSharp.sizes} />
				</Link>
			    </div>
			    <div style={{display: 'flex', flex: 3, justifyContent: 'flex-end'}}>
				<NavigationLinks />
			    </div>
			</Grid>
		    </Hidden>
		    <Hidden mdUp>
			<div style={{display: 'flex', width: '100%', maxWidth: 768, margin: 'auto'}}>
			    <div style={{flex: 1}}>
				<Link to="/"
				      style={{fontFamily: "Nunito"}}
				      className="hover">
				    Share Meals
				</Link>
			    </div>
			    <div style={{flex: 1, textAlign: 'right'}}>
				<a className="hover" style={{cursor: 'pointer'}}
				onClick={this.toggleSideMenu}>
				    <MenuIcon />
				</a>
			    </div>
			</div>
		    </Hidden>
		</Toolbar>
		{drawer}
	    </AppBar>
	)
    }
}



// WEBPACK FOOTER //
// ./src/components/header.jsx